import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CreatorFanList from './creatorFanList';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchFanList } from '../../utils/api';
import { useProfileData } from '../../hooks/useProfileData';

export interface FanDataType {
  fans: {
    full_name: string;
    profile_pic_url: string;
    user_id: string;
    user_name: string;
    user_type: string;
  }[];
  total_fans: number;
}

const CreatorFanData: React.FC = () => {
  const { creatorProfileData, isLoadingProfile } = useProfileData();
  const { userId = '' } = creatorProfileData || {};

  const { data: fanData, isLoading } = useSuspenseQuery({
    queryKey: ['creators-fan-data', userId],
    queryFn: async () => {
      if (!userId) {
        return {fans: [], total_fans: 0}
      }
      return await fetchFanList(userId, 25);
    },
    staleTime: Infinity,
  });

  if (isLoadingProfile || isLoading) {
    return <></>
  }

  return (
    (!!fanData && !!fanData.total_fans) ?
        <Box width="100%">
          <Typography
            component="p"
            variant="body2"
            color="text.secondary"
            sx={{ userSelect: 'text' }}
          >
            Fans
          </Typography>
          <CreatorFanList fanData={fanData} />
        </Box> :
        <></> // skip if no data
  );
}

export default CreatorFanData;
